import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { MathPlus, MathMinus } from 'styled-cssgg';
import cx from 'classnames';
import { shadow } from '../theme/shadow';
import { borderRadius } from '../theme/border-radius';
const Input = styled.input `
  appearance: none;
  border: none;
  box-shadow: none;
  padding: 0px;
  color: var(--text-color-0);
  background-color: transparent;
  box-sizing: border-box;
  outline: none;
  text-indent: 2px;
  line-height: 16px;
  width: 100%;

  &::placeholder {
    color: var(--text-color-2);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const Wrapper = styled.div `
  position: relative;
  width: 100px;
  height: 28px;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  overflow: visible;
  border-radius: ${borderRadius.md};
  border: 1px solid var(--border-color);
  padding: 2px 2px;
  background-color: white;
  border-color: ${() => 'var(--border-color)'};
  display: flex;
  align-items: center;
  --ggs: 0.75;
`;
const Icon = styled.i `
  box-shadow: ${shadow.lg};
  background-color: var(--primary);
  color: var(--primary-text-color);
  aspect-ratio: 1;
  height: 22px;
  border-radius: ${borderRadius.md};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const InputNumber = (props) => {
    const [value, setValue] = useState();
    const handleChange = useCallback((e) => {
        var _a;
        const num = e.target.value === '' ? undefined : Number(e.target.value);
        setValue(e.target.value);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, num);
    }, []);
    const handleAdd = useCallback(() => {
        setValue((prev) => {
            var _a;
            const next = (prev !== null && prev !== void 0 ? prev : 0) + 1;
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, next);
            return next;
        });
    }, []);
    const handleMinus = useCallback(() => {
        setValue((prev) => {
            var _a;
            const next = (prev !== null && prev !== void 0 ? prev : 0) - 1;
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, next);
            return next;
        });
    }, []);
    const controlledValue = props.value || value;
    return (React.createElement(Wrapper, { className: cx('input-number', props.className), "data-role": "input-number" },
        React.createElement(Icon, { className: "input-number-prefix", onClick: handleMinus },
            React.createElement(MathMinus, null)),
        React.createElement(Input, { className: "input-number-input", value: controlledValue, onChange: handleChange, type: "number" }),
        React.createElement(Icon, { className: "input-number-suffix", onClick: handleAdd },
            React.createElement(MathPlus, null))));
};
